import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const RevivedIcon = (props: SvgProps) => (
    <Svg width={props.width ?? 16} height={props.height ?? 16} viewBox="0 0 16 16" fill="none" {...props}>
        <Path d="M15 8H12.5556L10 4L6 12L3.5 8H1" stroke={props.color || ds.colorValue.icon.primary} strokeWidth={2} />
    </Svg>
);
